import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Banner, Process, Pricing, ProjectSection, Partners, Calculator, Mission } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Mission /> {/* Mission section */}
      <Services /> {/* Services Slider */}
      <Counter /> {/* Counter Section */}
      <Process /> {/* Process section */}
      <Banner /> {/* Banner Section */}
      <ProjectSection /> {/* Projects Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <Calculator /> {/* Calculator section */}
      <Pricing /> {/* Pricing section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;